import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/index';
import {shareReplay} from 'rxjs/internal/operators';

@Injectable()
export class KeywordService {
    private endpoint: string = '/keywords';

    constructor(
        private httpClient: HttpClient
    ) {
    }

    getKeywords(ids): Observable<any[]> {
        return this.httpClient.get<any[]>(environment.apiURL + this.endpoint, {
            params: new HttpParams().set('ids', ids).set('keyword_complications', '1').set('all', '1')
        }).pipe(shareReplay());
    }
}
